import AxiosService from './AxiosService'

class TlsRestService {
  get(): Promise<any> {
    return AxiosService.get('/certificates')
  }

  getTlsKeys(): Promise<any> {
    return AxiosService.get('/certificates/tls/keys')
  }

  getTlsKeysWithCerts(): Promise<any> {
    return AxiosService.get('/certificates/tls/keysWithCerts')
  }

  deleteTlsKey(keyId: string, version: number): Promise<any> {
    return AxiosService.delete(`/certificates/tls/keys/${keyId}/${version}`)
  }

  download(id: number): Promise<any> {
    return AxiosService.get('/certificates/' + id, { responseType: 'blob' })
  }

  importCert(certificate: any): Promise<any> {
    return AxiosService.post('/certificates/', certificate)
  }

  delete(id: number): Promise<any> {
    return AxiosService.delete('/certificates/' + id)
  }

  getKeystoreAliases(keystore: any): Promise<any> {
    return AxiosService.post('/certificates/keystore/aliases', keystore)
  }

  importKeystore(keystore: any): Promise<any> {
    return AxiosService.post('/certificates/keystore/', keystore)
  }
}

export default new TlsRestService()
